import { render, staticRenderFns } from "./TransactionNftTable.vue?vue&type=template&id=01695620&scoped=true"
import script from "./TransactionNftTable.vue?vue&type=script&lang=js"
export * from "./TransactionNftTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionNftTable.vue?vue&type=style&index=0&id=01695620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01695620",
  null
  
)

export default component.exports